<template>
  <!-- Dialog Share -->
  <ib-dialog
    id="dialog-share"
    :visible="visible"
    top="8vh"
    empty-header
    width="530px"
    @close="closeDialog"
  >
    <!-- Image -->
    <div class="text-center dialog-share-icon">
      <img src="@/assets/img/illustrations/share-financials.svg" alt="">
    </div>
    <!-- /Image -->

    <!-- Title -->

    <div class="text-center font-outfit-medium dialog-share-title">
      {{ title }}
    </div>

    <!-- /Title -->

    <div class="form-wrapper">
      <el-form ref="form">
        <!-- Share Link -->
        <div class="text-center font-outfit-regular dialog-share-description">
          {{ $t('dialogs.share.copyLinkAndShare') }}
        </div>
        <el-form-item class="label-outside">
          <el-input
            :value="shareLink"
            placeholder=" "
            :readonly="true"
          />
          <a class="copy-link" @click="doCopy">
            {{ $t('dialogs.share.copyLink') }}
          </a>
        </el-form-item>

        <!-- /Share Link -->
      </el-form>
    </div>
  </ib-dialog>
  <!-- /Dialog Share -->
</template>

<script>
const types = ['ideaPlan', 'financialPlan', 'businessPlan']

const routes = {
  ideaPlan: 'idea-plan-shared',
  financialPlan: 'financial-plan-shared',
  businessPlan: 'business-plan-shared'
}

export default {
  name: 'DialogShare',

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: null
    },

    token: {
      type: String,
      default: null,
      required: true
    },
    type: {
      type: String,
      validator: value => {
        return types.includes(value)
      },
      required: true
    }
  },

  computed: {
    shareLink () {
      if (!this.token) return
      const route = this.$router.resolve({
        name: routes[this.type],
        params: { token: this.token }
      })

      return `${window.location.origin}${route.href}?lang=${localStorage.getItem('lang')}`
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    doCopy: function () {
      this.$copyText(this.shareLink)
      this.$notify({ title: 'Success', message: 'Share Link has been copied', type: 'success' })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog-share-icon {
  margin: 45px 0 35px;
}

.dialog-share-title {
  font-size: 30px;
  color: $color-font !important;
}

.dialog-share-description {
  font-size: 18px;
  color: $color-font !important;
  opacity: .6;
  margin: 10px 0;
}
</style>
